/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AccountResource', 'model/AccountRestrictionsResponse', 'model/AccountRoleRemovedResource', 'model/AccountRoleResource', 'model/AccountsResponse', 'model/ChangePasswordResource', 'model/RegisterAccountResource', 'model/ResponseAccountResponse', 'model/ResponseObject'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/AccountResource'), require('../model/AccountRestrictionsResponse'), require('../model/AccountRoleRemovedResource'), require('../model/AccountRoleResource'), require('../model/AccountsResponse'), require('../model/ChangePasswordResource'), require('../model/RegisterAccountResource'), require('../model/ResponseAccountResponse'), require('../model/ResponseObject'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.AccountsApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.AccountResource, root.GisServerApis.AccountRestrictionsResponse, root.GisServerApis.AccountRoleRemovedResource, root.GisServerApis.AccountRoleResource, root.GisServerApis.AccountsResponse, root.GisServerApis.ChangePasswordResource, root.GisServerApis.RegisterAccountResource, root.GisServerApis.ResponseAccountResponse, root.GisServerApis.ResponseObject);
  }
}(this, function(ApiClient, AccountResource, AccountRestrictionsResponse, AccountRoleRemovedResource, AccountRoleResource, AccountsResponse, ChangePasswordResource, RegisterAccountResource, ResponseAccountResponse, ResponseObject) {
  'use strict';

  /**
   * Accounts service.
   * @module api/AccountsApi
   * @version 1.0.0
   */

  /**
   * Constructs a new AccountsApi. 
   * @alias module:api/AccountsApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addAccountsToRolesV1 operation.
     * @callback module:api/AccountsApi~addAccountsToRolesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add accounts to roles.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/AccountRoleResource>} opts.items A collection of an item which includes the ID of account, ID of role and expiration.
     * @param {module:model/String} opts.mapMode How the roles will be added. \&quot;Append\&quot; only adds any new roles to the specified account. \&quot;Reset\&quot; first removes all roles and then adds only the roles specified here.
     * @param {module:api/AccountsApi~addAccountsToRolesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.addAccountsToRolesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['items'];


      var pathParams = {
      };
      var queryParams = {
        'mapMode': opts['mapMode'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/roles', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the addRestrictionsToAccountV1 operation.
     * @callback module:api/AccountsApi~addRestrictionsToAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add restrictions to account.
     * @param {String} accountId The ID of the account to which you want to add the restrictions.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.restrictionIds The IDs of one or more restrictions you want to add to the account.
     * @param {module:model/String} opts.mapMode How the restrictions will be added. \&quot;Append\&quot; only adds any new restrictions to the specified account. \&quot;Reset\&quot; first removes all restrictions and then adds only the restrictions specified here.
     * @param {module:api/AccountsApi~addRestrictionsToAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.addRestrictionsToAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling addRestrictionsToAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'mapMode': opts['mapMode'],
      };
      var collectionQueryParams = {
        'restrictionIds': {
          value: opts['restrictionIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/restrictions', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the changeAccountPasswordV1 operation.
     * @callback module:api/AccountsApi~changeAccountPasswordV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Change your account password.
     * This API is intended for browser use. To use it, you must authenticate with the resource owner credentials of the account whose password you want to change.  You cannot use this API to change the password for an account other than your own.
     * @param {Object} opts Optional parameters
     * @param {module:model/ChangePasswordResource} opts.model An object containing your account&#39;s current password, the new password, and a confirmation copy of the new password.
     * @param {module:api/AccountsApi~changeAccountPasswordV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.changeAccountPasswordV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['model'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/changepassword', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createAccountV1 operation.
     * @callback module:api/AccountsApi~createAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new account.
     * @param {Object} opts Optional parameters
     * @param {module:model/RegisterAccountResource} opts.account Details of the account to be created. Name and password are required. Nickname and description are optional.
     * @param {module:api/AccountsApi~createAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseAccountResponse}
     */
    this.createAccountV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['account'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteAccountByIdV1 operation.
     * @callback module:api/AccountsApi~deleteAccountByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete an account.
     * @param {String} accountId The ID of the account to be deleted.
     * @param {module:api/AccountsApi~deleteAccountByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteAccountByIdV1 = function(accountId, callback) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling deleteAccountByIdV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteAccountsByIdsV1 operation.
     * @callback module:api/AccountsApi~deleteAccountsByIdsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete multiple accounts.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.accountIds A list of IDs of the accounts to be deleted.
     * @param {module:api/AccountsApi~deleteAccountsByIdsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.deleteAccountsByIdsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'accountIds': {
          value: opts['accountIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAccountByIdV1 operation.
     * @callback module:api/AccountsApi~getAccountByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get an account by ID.
     * @param {String} accountId The ID of the account you want to get.
     * @param {module:api/AccountsApi~getAccountByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseAccountResponse}
     */
    this.getAccountByIdV1 = function(accountId, callback) {
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getAccountByIdV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAccountsByRestrictionV1 operation.
     * @callback module:api/AccountsApi~getAccountsByRestrictionV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get accounts having the specified restriction.
     * @param {String} restrictionId The ID of the applicable restriction.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The offset from which to start retrieving account records; e.g. begin with the 30th record. Defaults to 0.
     * @param {Number} opts.length How many accounts to return. Defaults to the maximum limit supported by the database server.
     * @param {module:model/String} opts.returnMode What account properties to return (all, count only, ID only, name only, or URI only). Defaults to all.
     * @param {String} opts.whereClause Optional account name filter. The account&#39;s name must contain this value to be included in the results. Defaults to null.
     * @param {module:api/AccountsApi~getAccountsByRestrictionV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountsResponse}
     */
    this.getAccountsByRestrictionV1 = function(restrictionId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'restrictionId' is set
      if (restrictionId === undefined || restrictionId === null) {
        throw new Error("Missing the required parameter 'restrictionId' when calling getAccountsByRestrictionV1");
      }


      var pathParams = {
        'restrictionId': restrictionId
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = AccountsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/restriction/{restrictionId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAccountsByRoleV1 operation.
     * @callback module:api/AccountsApi~getAccountsByRoleV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get accounts having the specified role.
     * @param {String} roleId The ID of the applicable role.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The offset from which to start retrieving account records; e.g. begin with the 30th record. Defaults to 0.
     * @param {Number} opts.length How many accounts to return. Defaults to the maximum limit supported by the database server.
     * @param {module:model/String} opts.returnMode What account properties to return (all, count only, ID only, name only, or URI only). Defaults to all.
     * @param {String} opts.whereClause Optional account name filter. The account&#39;s name must contain this value to be included in the results. Defaults to null.
     * @param {module:api/AccountsApi~getAccountsByRoleV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountsResponse}
     */
    this.getAccountsByRoleV1 = function(roleId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'roleId' is set
      if (roleId === undefined || roleId === null) {
        throw new Error("Missing the required parameter 'roleId' when calling getAccountsByRoleV1");
      }


      var pathParams = {
        'roleId': roleId
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = AccountsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/role/{roleId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAccountsV1 operation.
     * @callback module:api/AccountsApi~getAccountsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get accounts.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The offset from which to start retrieving account records; e.g. begin with the 30th record. Defaults to 0.
     * @param {Number} opts.length How many accounts to return. Defaults to the maximum limit supported by the database server.
     * @param {module:model/String} opts.returnMode What account properties to return (all, count only, ID only, name only, or URI only). Defaults to all.
     * @param {String} opts.whereClause Optional account name filter. The account&#39;s name must contain this value to be included in the results. Defaults to null.
     * @param {module:api/AccountsApi~getAccountsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountsResponse}
     */
    this.getAccountsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = AccountsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getCurrentAccountV1 operation.
     * @callback module:api/AccountsApi~getCurrentAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get current account.
     * @param {module:api/AccountsApi~getCurrentAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseAccountResponse}
     */
    this.getCurrentAccountV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/current', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getRestrictionsForAccountV1 operation.
     * @callback module:api/AccountsApi~getRestrictionsForAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/AccountRestrictionsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the restrictions applicable to an account.
     * @param {String} accountId The ID of the account whose restrictions you want to get.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.offset The offset from which to start retrieving restriction records; e.g. begin with the 30th record. Defaults to 0.
     * @param {Number} opts.length How many restrictions to return. Defaults to the maximum limit supported by the database server.
     * @param {module:model/String} opts.returnMode What restriction properties to return (all, count only, ID only, name only, or URI only). Defaults to all.
     * @param {String} opts.whereClause Optional restriction name filter. The name of the restriction must contain this value to be included in the results. Defaults to null.
     * @param {module:api/AccountsApi~getRestrictionsForAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AccountRestrictionsResponse}
     */
    this.getRestrictionsForAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling getRestrictionsForAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
        'offset': opts['offset'],
        'length': opts['length'],
        'returnMode': opts['returnMode'],
        'whereClause': opts['whereClause'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = AccountRestrictionsResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/restrictions', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removeAccountsFromRolesV1 operation.
     * @callback module:api/AccountsApi~removeAccountsFromRolesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove the specified accounts from roles.
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/AccountRoleRemovedResource>} opts.items A collection of the resource you want to remove the accounts from the roles.
     * @param {module:api/AccountsApi~removeAccountsFromRolesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removeAccountsFromRolesV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['items'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/roles', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the removeRestrictionsFromAccountV1 operation.
     * @callback module:api/AccountsApi~removeRestrictionsFromAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseObject} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove restrictions from an account.
     * @param {String} accountId The ID of the account from which to remove the restrictions.
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.restrictionIds The IDs of the restrictions you want to remove from the account.
     * @param {module:api/AccountsApi~removeRestrictionsFromAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseObject}
     */
    this.removeRestrictionsFromAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling removeRestrictionsFromAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
        'restrictionIds': {
          value: opts['restrictionIds'],
          collectionFormat: 'multi'
        },
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseObject;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}/restrictions', 'DELETE',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateAccountV1 operation.
     * @callback module:api/AccountsApi~updateAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an account.
     * @param {String} accountId The ID of the account to be updated.
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountResource} opts.account The revised account information.
     * @param {module:api/AccountsApi~updateAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseAccountResponse}
     */
    this.updateAccountV1 = function(accountId, opts, callback) {
      opts = opts || {};
      var postBody = opts['account'];

      // verify the required parameter 'accountId' is set
      if (accountId === undefined || accountId === null) {
        throw new Error("Missing the required parameter 'accountId' when calling updateAccountV1");
      }


      var pathParams = {
        'accountId': accountId
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/{accountId}', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCurrentAccountV1 operation.
     * @callback module:api/AccountsApi~updateCurrentAccountV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update current account.
     * @param {Object} opts Optional parameters
     * @param {module:model/AccountResource} opts.account The revised account information.
     * @param {module:api/AccountsApi~updateCurrentAccountV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseAccountResponse}
     */
    this.updateCurrentAccountV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['account'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseAccountResponse;

      return this.apiClient.callApi(
        '/api/v1/accounts/current', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

